/**
 * ユーザ情報詳細ポップアップ用インプットVO
 */
export class KYMW9005InputModel {
  /** ユーザID */
  public associatedUserId: string = <string>'';
}